import { Region } from "../models/calculation-api.types";
import { CalculatorV2RegionConfigurationModel } from "../models/calculator-configuration";
import { CalculatorQuestion } from "../models/CalculatorStep";
import { FamilyFormState } from "../models/FamilyFormState";

export function filterVisibleQuestions(
  questions: CalculatorQuestion[],
  state: FamilyFormState,
  region: Region,
): CalculatorQuestion[] {
  return questions.filter((question) => {
    if (question.visible) {
      return question.visible(state, region);
    }

    return true;
  });
}
